/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCollectedServiceDelete } from '../fn/collected-service/api-collected-service-delete';
import { ApiCollectedServiceDelete$Params } from '../fn/collected-service/api-collected-service-delete';
import { apiCollectedServiceIdGet$Json } from '../fn/collected-service/api-collected-service-id-get-json';
import { ApiCollectedServiceIdGet$Json$Params } from '../fn/collected-service/api-collected-service-id-get-json';
import { apiCollectedServiceIdGet$Plain } from '../fn/collected-service/api-collected-service-id-get-plain';
import { ApiCollectedServiceIdGet$Plain$Params } from '../fn/collected-service/api-collected-service-id-get-plain';
import { apiCollectedServicePost$Json } from '../fn/collected-service/api-collected-service-post-json';
import { ApiCollectedServicePost$Json$Params } from '../fn/collected-service/api-collected-service-post-json';
import { apiCollectedServicePost$Plain } from '../fn/collected-service/api-collected-service-post-plain';
import { ApiCollectedServicePost$Plain$Params } from '../fn/collected-service/api-collected-service-post-plain';
import { apiCollectedServicePut$Json } from '../fn/collected-service/api-collected-service-put-json';
import { ApiCollectedServicePut$Json$Params } from '../fn/collected-service/api-collected-service-put-json';
import { apiCollectedServicePut$Plain } from '../fn/collected-service/api-collected-service-put-plain';
import { ApiCollectedServicePut$Plain$Params } from '../fn/collected-service/api-collected-service-put-plain';
import { apiCollectedServiceStartDateStringEndDateStringGet$Json } from '../fn/collected-service/api-collected-service-start-date-string-end-date-string-get-json';
import { ApiCollectedServiceStartDateStringEndDateStringGet$Json$Params } from '../fn/collected-service/api-collected-service-start-date-string-end-date-string-get-json';
import { apiCollectedServiceStartDateStringEndDateStringGet$Plain } from '../fn/collected-service/api-collected-service-start-date-string-end-date-string-get-plain';
import { ApiCollectedServiceStartDateStringEndDateStringGet$Plain$Params } from '../fn/collected-service/api-collected-service-start-date-string-end-date-string-get-plain';
import { CollectedServiceDetailDto } from '../models/collected-service-detail-dto';
import { ServiceOverviewDto } from '../models/service-overview-dto';

@Injectable({ providedIn: 'root' })
export class CollectedServiceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCollectedServiceStartDateStringEndDateStringGet()` */
  static readonly ApiCollectedServiceStartDateStringEndDateStringGetPath = '/api/CollectedService/{startDateString}/{endDateString}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServiceStartDateStringEndDateStringGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceStartDateStringEndDateStringGet$Plain$Response(params: ApiCollectedServiceStartDateStringEndDateStringGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServiceOverviewDto>>> {
    return apiCollectedServiceStartDateStringEndDateStringGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServiceStartDateStringEndDateStringGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceStartDateStringEndDateStringGet$Plain(params: ApiCollectedServiceStartDateStringEndDateStringGet$Plain$Params, context?: HttpContext): Observable<Array<ServiceOverviewDto>> {
    return this.apiCollectedServiceStartDateStringEndDateStringGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ServiceOverviewDto>>): Array<ServiceOverviewDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServiceStartDateStringEndDateStringGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceStartDateStringEndDateStringGet$Json$Response(params: ApiCollectedServiceStartDateStringEndDateStringGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServiceOverviewDto>>> {
    return apiCollectedServiceStartDateStringEndDateStringGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServiceStartDateStringEndDateStringGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceStartDateStringEndDateStringGet$Json(params: ApiCollectedServiceStartDateStringEndDateStringGet$Json$Params, context?: HttpContext): Observable<Array<ServiceOverviewDto>> {
    return this.apiCollectedServiceStartDateStringEndDateStringGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ServiceOverviewDto>>): Array<ServiceOverviewDto> => r.body)
    );
  }

  /** Path part for operation `apiCollectedServiceIdGet()` */
  static readonly ApiCollectedServiceIdGetPath = '/api/CollectedService/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServiceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceIdGet$Plain$Response(params: ApiCollectedServiceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServiceIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServiceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceIdGet$Plain(params: ApiCollectedServiceIdGet$Plain$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServiceIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServiceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceIdGet$Json$Response(params: ApiCollectedServiceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServiceIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServiceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceIdGet$Json(params: ApiCollectedServiceIdGet$Json$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServiceIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /** Path part for operation `apiCollectedServicePut()` */
  static readonly ApiCollectedServicePutPath = '/api/CollectedService';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServicePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePut$Plain$Response(params?: ApiCollectedServicePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServicePut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServicePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePut$Plain(params?: ApiCollectedServicePut$Plain$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServicePut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServicePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePut$Json$Response(params?: ApiCollectedServicePut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServicePut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServicePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePut$Json(params?: ApiCollectedServicePut$Json$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServicePut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /** Path part for operation `apiCollectedServicePost()` */
  static readonly ApiCollectedServicePostPath = '/api/CollectedService';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServicePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePost$Plain$Response(params?: ApiCollectedServicePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServicePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServicePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePost$Plain(params?: ApiCollectedServicePost$Plain$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServicePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServicePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePost$Json$Response(params?: ApiCollectedServicePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
    return apiCollectedServicePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServicePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCollectedServicePost$Json(params?: ApiCollectedServicePost$Json$Params, context?: HttpContext): Observable<CollectedServiceDetailDto> {
    return this.apiCollectedServicePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CollectedServiceDetailDto>): CollectedServiceDetailDto => r.body)
    );
  }

  /** Path part for operation `apiCollectedServiceDelete()` */
  static readonly ApiCollectedServiceDeletePath = '/api/CollectedService';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCollectedServiceDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceDelete$Response(params?: ApiCollectedServiceDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiCollectedServiceDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCollectedServiceDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCollectedServiceDelete(params?: ApiCollectedServiceDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiCollectedServiceDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
